import React, { useEffect, useState, useRef } from 'react';
import './Answers.css';

export default function RadioButton({ onSelect99, setFirst, answers5, first, answers, answers2, onSelect, onSelect2, language, answers3, languagecode, setLanguage, setLanguagecode, setParentlanguage, setParentlanguagecode, role, parentlanguage, town }) {

  const scrollview_ref = useRef();

  const selectHandler = (item) => {
    if (role == "Student") {
      setLanguagecode(item.code);
      console.log(item.code, "This is the value");
    }
  };

  const selectHandler26 = (item) => {
    console.log(item, "this is what was just selected", role)
    onSelect(item.value);
    setLanguage(item.value);
    setLanguagecode(item.code);
  };

  const selectHandler27 = (item) => {
    console.log(item, "this is what was just selected", role)
    onSelect2(item.value);
    setParentlanguage(item.value);
    setParentlanguagecode(item.code);
  };

  const selectHandler2 = (item) => {
    if (role == "Student") {
      setLanguage(item.value);
      setLanguagecode(item.code);
      console.log(item.value, "This is the value");
    }
  };

  const selectHandler3 = (item) => {
    selectHandler(item);
    selectHandler2(item);
  };

  const selectHandler0 = (item) => {
    setParentlanguagecode(item.code);
    console.log(item.code, "This is the value");
  };

  const selectHandler20 = (item) => {
    setParentlanguage(item.value);
    console.log(item.value, "This is the value");
  };

  const selectHandler30 = (item) => {
    if (role == "Student") {
      selectHandler0(item);
      selectHandler20(item);
    }
  };

  const selectHandler29 = (item) => {
    if (role != "Student") {
      onSelect99(item.value)
      setFirst(item.value)
    }
  };

  useEffect(() => {
    if (scrollview_ref.current) {
      scrollview_ref.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, []);

  const styles = {
    option: {
      fontSize: 20,
      color: 'rgba(255, 0, 0, 1)',
      textAlign: 'center',
    },
    unselected: {
      color: "#fff",
      backgroundColor: "#013469",
      margin: 6,
      fontSize: 20,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 10,
      marginRight: 10,
      padding: "8px",
      cursor: "pointer"
    },
    selected: {
      color: "#fff",
      backgroundColor: "#E43522",
      margin: 6,
      fontSize: 20,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 10,
      marginRight: 10,
      padding: "8px",
      cursor: "pointer"
    },
  };

  return (
    <div className="answers-scrollable-container" ref={scrollview_ref}>
      {typeof answers5 != "undefined" && role != "Student" ? answers5.map((item, i) => {
        return (
          <div key={i}>
            <div
              style={item.value == first ? styles.selected : styles.unselected}
              onClick={() => selectHandler29(item)}>
              {item.value}
            </div>
          </div>
        );
      }) : answers && language == "" ? answers.map((item, i) => {
        return (
          <div key={i}>
            <div
              style={item.value == first ? styles.selected : styles.unselected}
              onClick={() => selectHandler26(item)}>
              {item.value}
            </div>
          </div>
        );
      }) : answers2 && parentlanguage == "" ? answers2.map((item, i) => {
        return (
          <div key={i}>
            <div
              style={item.value == first ? styles.selected : styles.unselected}
              onClick={() => selectHandler27(item)}>
              {item.value}
            </div>
          </div>
        );
      }) : answers ? answers.map((item, i) => {
        return (
          <div key={i}>
            <div
              style={item.value == first ? styles.selected : styles.unselected}
              onClick={() => selectHandler3(item)}>
              {item.value}
            </div>
          </div>
        );
      }) : answers2 ? answers2.map((item, i) => {
        return (
          <div key={i}>
            <div
              style={item.value == first ? styles.selected : styles.unselected}
              onClick={() => selectHandler30(item)}>
              {item.value}
            </div>
          </div>
        );
      }) : null}
    </div>
  );
}